import { Component } from '@angular/core';
import {
  MatDialogRef,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'app-reference-files-dialog',
  templateUrl: './reference-files-dialog.component.html',
  styleUrls: ['./reference-files-dialog.component.scss'],
  imports: [MatDialogContent, MatDialogTitle],
})
export class ReferenceFilesDialogComponent {
  constructor(public dialogRef: MatDialogRef<ReferenceFilesDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
